import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hook/use-http";
import ChartLoader from "../ChartLoader";
import NoData from "../NoData";
import { Chart } from 'react-google-charts';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import BucketsTableBMSVehicle from "./BucketsTableBMSVehicle";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let res_result
let Maxchartdata
let bartype

export default function BMS_vehicle({ apiend, gloablfilter, type, chartBMSDropdown }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredDataMin, SetfilteredDataMin] = useState([]);
  const [filteredDataMax, SetfilteredDataMax] = useState([]);
  const [barTypeClick, SetBarTypeClick] = useState(0);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  let modal_title = "";

  let toPushMin = []
  let toPushMax = []
  const appyData = (data) => {
    let dropdownname; 
    if(chartBMSDropdown === 'BMS_Min_Cell_Voltage'){
      dropdownname = 'Min'
    }else{
      dropdownname = 'Max'
    }
    res_result = data;

    let responceout = {
      "<2.6": 0,
      "2.7": 0,
      "2.8": 0,
      "2.9": 0,
      "3": 0,
      "3.1": 0,
      "3.2": 0,
      "3.3": 0,
      "3.4": 0,
      "3.5": 0,
      "3.6": 0,
      "3.7": 0,
      "3.8": 0,
      "3.9": 0,
      "4": 0,
      ">=4": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);

      let temp_result = res_result[0];


      if (temp_result.doc_count != 0) {
      //   if (temp_result.Minless_26.value) {
      //     responce["<2.6"] = temp_result.Minless_26.value;
      //   }

      if (temp_result.doc_count != 0) {
        if (temp_result[dropdownname + "less_26"].value) {
          responceout["<2.6"] = temp_result[dropdownname + "less_26"].value;
        }
        if (temp_result[dropdownname + "26_27"].value) {
          responceout["2.7"] = temp_result[dropdownname + "26_27"].value;
        }
        if (temp_result[dropdownname + "27_28"].value) {
          responceout["2.8"] = temp_result[dropdownname + "27_28"].value;
        }
        if (temp_result[dropdownname + "28_29"].value) {
          responceout["2.9"] = temp_result[dropdownname + "28_29"].value;
        }
        if (temp_result[dropdownname + "29_30"].value) {
          responceout["3"] = temp_result[dropdownname + "29_30"].value;
        }
        if (temp_result[dropdownname + "30_31"].value) {
          responceout["3.1"] = temp_result[dropdownname + "30_31"].value;
        }
        if (temp_result[dropdownname + "31_32"].value) {
          responceout["3.2"] = temp_result[dropdownname + "31_32"].value;
        }
        if (temp_result[dropdownname + "32_33"].value) {
          responceout["3.3"] = temp_result[dropdownname + "32_33"].value;
        }
        if (temp_result[dropdownname + "33_34"].value) {
          responceout["3.4"] = temp_result[dropdownname + "33_34"].value;
        }
        if (temp_result[dropdownname + "34_35"].value) {
          responceout["3.5"] = temp_result[dropdownname + "34_35"].value;
        }
        if (temp_result[dropdownname + "35_36"].value) {
          responceout["3.6"] = temp_result[dropdownname + "35_36"].value;
        }
        if (temp_result[dropdownname + "36_37"].value) {
          responceout["3.7"] = temp_result[dropdownname + "36_37"].value;
        }
        if (temp_result[dropdownname + "37_38"].value) {
          responceout["3.8"] = temp_result[dropdownname + "37_38"].value;
        }
        if (temp_result[dropdownname + "38_39"].value) {
          responceout["3.9"] = temp_result[dropdownname + "38_39"].value;
        }
        if (temp_result[dropdownname + "39_40"].value) {
          responceout["4"] = temp_result[dropdownname + "39_40"].value;
        }
        if (temp_result[dropdownname + "gre_4"].value) {
          responceout[">=4"] = temp_result[dropdownname + "gre_4"].value;
        }

        toPushMax.push(temp_result[dropdownname + "less_26"].value)
        toPushMax.push(temp_result[dropdownname + "26_27"].value)
        toPushMax.push(temp_result[dropdownname + "27_28"].value)
        toPushMax.push(temp_result[dropdownname + "28_29"].value)
        toPushMax.push(temp_result[dropdownname + "29_30"].value)
        toPushMax.push(temp_result[dropdownname + "30_31"].value)
        toPushMax.push(temp_result[dropdownname + "31_32"].value)
        toPushMax.push(temp_result[dropdownname + "32_33"].value)
        toPushMax.push(temp_result[dropdownname + "33_34"].value)
        toPushMax.push(temp_result[dropdownname + "34_35"].value)
        toPushMax.push(temp_result[dropdownname + "35_36"].value)
        toPushMax.push(temp_result[dropdownname + "36_37"].value)
        toPushMax.push(temp_result[dropdownname + "37_38"].value)
        toPushMax.push(temp_result[dropdownname + "38_39"].value)
        toPushMax.push(temp_result[dropdownname + "39_40"].value)
        toPushMax.push(temp_result[dropdownname + "gre_4"].value)
        SetfilteredDataMax(toPushMax)
      }

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responceout);

      loop_keys = ["<2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5", "3.6", "3.7", "3.8", "3.9", "4", ">=4"]
      loop_keys.map(x => {
        if(type === 'Slow'){
          res_result_final.push([x, responceout[x], `{stroke-width: 1;stroke-color: black;color:${"#348393"}}`]);
        }else{
          res_result_final.push([x, responceout[x], `{stroke-width: 1;stroke-color: black;color:${"#F39C48"}}`]);
        }
      })
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }

    let colorMin, colorMax
    if (type === "Slow") {
      colorMin = "#348393"
      colorMax = "#89CCD8"
    } else {
      colorMin = "#FFD1A4"
      colorMax = "#F39C48"
    }
    const labels = ["<2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5", "3.6", "3.7", "3.8", "3.9", "4", ">=4"];
    Maxchartdata = {
      labels,
      datasets: [
        {
          label: chartBMSDropdown,
          data: responceout,
          backgroundColor: colorMin,
          borderWidth: 1,
          borderColor: "black",
        }
      ]
    };
  }
  let hAxis = {};


  modal_title = "BMS cell voltage - " + type + " chrg";
  console.log("modal_title----",modal_title);
  console.log("type----",type);
  hAxis = {
    gridlines: {
      color: 'transparent'
    },
    title: 'Range (Km)',
    minValue: 0,
    format: 'short',
    direction: 1,
    slantedText: true,
    slantedTextAngle: 90
  };
}


  const appyDataClick = (data) => {
    let hits = data;
    if (chartBMSDropdown === 'BMS_Min_Cell_Voltage') {
      hits.map((i, key) => {
        toPushMin.push(i.fields.BMS_Min_Cell_Voltage[0])
      })
      SetfilteredDataMin(toPushMin)
    } else {
      hits.map((i, key) => {
        toPushMax.push(i.fields.BMS_Max_Cell_Voltage[0])
      })
      SetfilteredDataMin(toPushMax)
    }
  }


  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: chartBMSDropdown
        },
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
          align: 'start'
        },
        xAxes: [{
          barThickness : 73
      }]
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycle'
        }
      },
    },

    plugins: {
      legend: {
        position: false
      },
    }
  };

  const options = {
    borderColor: "black", // Border color for the bars
      borderWidth: 2, 
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: chartBMSDropdown,
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
  };
  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
  }, [gloablfilter, type, chartBMSDropdown])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">BMS cell voltage - {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }}>
              {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ?
                <Bar options={options1} data={Maxchartdata} width="100%" height="65px" /> : <NoData />
              )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ?
        <Chart chartType="ColumnChart" options={options} data={chartdata} width="100%" height="230px" chartEvents={[
          {
            eventName: "select",
            callback({ chartWrapper }) {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              const [selectedItem] = selection;
              const { row } = selectedItem;
              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              let from_bucket;
              let to_bucket;
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;
              if (count !== 0) {
                if (barvalue === "<2.6") {
                  from_bucket = 1
                  to_bucket = 2.6
                } else if (barvalue === "<=4") {
                  from_bucket = 3.9
                  to_bucket = 4
                } else {
                  from_bucket = barvalue - 0.1
                  to_bucket = barvalue
                }
                if ( type === "Slow" && chartBMSDropdown === 'BMS_Min_Cell_Voltage') {
                  fetchData({ url: API_URL_MAIN + "chargingpage_api/BMS_min_slow", body: { filterdata: gloablfilter, type: type, from_bucket: from_bucket, to_bucket: to_bucket } }, appyDataClick)
                } else if ( type === "Fast" && chartBMSDropdown === 'BMS_Min_Cell_Voltage') {
                  fetchData({ url: API_URL_MAIN + "chargingpage_api/BMS_min_fast", body: { filterdata: gloablfilter, type: type, from_bucket: from_bucket, to_bucket: to_bucket } }, appyDataClick)
                } else if ( type === "Slow" && chartBMSDropdown === 'BMS_Max_Cell_Voltage') {
                  fetchData({ url: API_URL_MAIN + "chargingpage_api/BMS_max_slow", body: { filterdata: gloablfilter, type: type, from_bucket: from_bucket, to_bucket: to_bucket } }, appyDataClick)
                } else if ( type === "Fast" && chartBMSDropdown === 'BMS_Max_Cell_Voltage') {
                  fetchData({ url: API_URL_MAIN + "chargingpage_api/BMS_max_fast", body: { filterdata: gloablfilter, type: type, from_bucket: from_bucket, to_bucket: to_bucket } }, appyDataClick)
                }
  
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        ]}
        /> : <NoData />
      )}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">BMS cell voltage - {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BucketsTableBMSVehicle data={filteredDataMin} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
